export const hasEmailTypo = email => {
  // basic listing of seen typos
  // be very careful not to block valid emails
  const commonTypos = [
    'gmai.com',
    'gmailo.com',
    'gmail.co',
    'gmail.om',
    'gmail.cm',
    'gmaik.com',
    'gmal.com',
    'gmil.com',
    'ahoo.com',
    'yaho.com',
    'yahoo.co',
    'yahoo.om',
    'yahoo.cm',
  ];

  const [_, domain] = email.split('@');
  
  return commonTypos.includes(domain);
}